/**
 * @example
 *
 * stripCSSUnit('18px')
 * //=> 18
 */
function stripCSSUnit(value) {
  return Number(value.replace(/[^-\d.]/g, ''));
}

export { stripCSSUnit };